<template>
  <div>
    <div>
      <Titulo :titulo="text" />
    </div>
    <!-- coger el parametro que se envio por la ruta -->
    <!-- {{$route.params.id}} -->

    <b-row>
      <b-col cols="12" md="8">
        <div class="margin-lateral">
          <h4 class="color-secundary mb-4">{{ intro }}</h4>
          <div class="text-justify">
            <div v-html="recomendacion" style="padding-right: 11%"></div>
          </div>
          <form @submit.prevent="cargue" id="cargue" enctype="multipart/form-data" style="padding-right: 13%">
            <b-form-file ref="archivo" required size="md" @change="fileChange()" placeholder="Selecione un archivo"
              browse-text="Anexar" drop-placeholder="Suelte los archivos aqui...." :disabled="loading" class="mt-2"
              :accept="informeCarga
                ? informeCarga.tipo_archivo
                  ? informeCarga.tipo_archivo
                  : '.txt'
                : '.txt'
                " :multiple="informeCarga ? (informeCarga.multiple ? true : false) : false
                  ">
              <!-- style="padding-right: 80px;" -->
              <template slot="file-name" slot-scope="{ names }">
                <b-badge v-if="names.length > 0" variant="dark" class="ml-1">{{ names[0] }} | {{ names.length }}
                  Archivo(s)
                  seleccionado(s)</b-badge>
              </template>
            </b-form-file>
            <br />
            <!-- <b-form-file
              ref="archivo_cliente"
              size="md"
              @change="fileChangeCliente()"
              placeholder="Selecione un archivo para actualización de cliente"
              browse-text="Anexar"
              drop-placeholder="Suelte los archivos aqui...."
              :disabled="loading"
              class="mt-2"
              :accept="
                informeCarga
                  ? informeCarga.tipo_archivo
                    ? informeCarga.tipo_archivo
                    : '.xlsx'
                  : '.xlsx'
              "
              :multiple="false"
              v-if="actualizacion_cliente_input"
            >
              <template slot="file-name" slot-scope="{ names }">
                <b-badge v-if="names.length > 0" variant="dark" class="ml-1"
                  >{{ names[0] }} | {{ names.length }} Archivo(s)
                  seleccionado(s)</b-badge
                >
              </template>
            </b-form-file> -->
            <b-alert show dismissible fade variant="primary" v-if="uploadResponse" class="mt-4"
              @dismissed="showDismissibleAlertSuccess = false">
              <div class="text-center titulo-alerta-succes">¡Alerta!</div>
              {{ uploadResponse.mensaje }}
              <ul>
                <li v-for="(value,
                  prerequisito,
                  index) in uploadResponse.prerequisitos" :key="index">
                  {{ prerequisito }}
                  <ul>
                    <li v-for="(_value, cargue, _index) in value" :key="_index">
                      {{ _value }}
                    </li>
                  </ul>
                </li>
              </ul>
            </b-alert>

            <b-alert show dismissible fade variant="danger" v-if="uploadRespnseError" class="mt-4"
              @dismissed="showDismissibleAlertError = false">
              <div class="text-center titulo-alerta-danger">¡Alerta!</div>
              <ul>
                <li v-for="(value, error, index) in uploadRespnseError" :key="index">
                  {{ error }}
                  <ul>
                    <li v-for="(_value, archivo, _index) in value" :key="_index">
                      {{ _value[0] }}
                    </li>
                  </ul>
                </li>
              </ul>
            </b-alert>
            <b-alert show dismissible fade variant="danger" v-if="!fileChecked && name !== null" class="mt-4"
              @dismissed="showDismissibleAlertError = false">
              <div class="text-center titulo-alerta-danger">¡Alerta!</div>
              <ul>
                <li>
                  El archivo no corresponde al tipo de cargue
                </li>
              </ul>
            </b-alert>

            <div class="mt-3 text-right">
              <img v-if="loading" class="loading" src="@/assets/images/loader.gif" alt />
              <!--b-button type="button" @click="limpiarInputReset" variant="outline-primary" :disabled="loading" class="ml-1">Limpiar</b-button-->
              <b-button type="submit" :disabled="loading || !fileChecked" class="ml-1 button-carga">Enviar</b-button>
            </div>
          </form>
        </div>
      </b-col>
      <!-- Panel Derecho -->
      <BannerRight />
    </b-row>
  </div>
</template>
<script>
import SelectNovedad from "@/data/SelectQueEsNovedad.json";
import SelectTipoNovedad from "@/data/SelectTipoNovedad.json";
import { mapGetters } from "vuex";

export default {
  name: "SubirArchivo",
  data: () => {
    return {
      files: new FormData(),
      uploadResponse: null,
      uploadRespnseError: null,
      SelectNovedad: SelectNovedad,
      SelectTipoNovedad: SelectTipoNovedad,
      selectQueEsNovedad: "",
      selectTipoNovedad: "",
      showDismissibleAlertSuccess: false,
      showDismissibleAlertError: false,
      text: "",
      intro: "",
      recomendacion: "",
      actualizacion_cliente_input: false,
      name: null,
      fileChecked: false,
    };
  },
  computed: {
    bancos_facturacion() {
      return this.$store.getters["pages/titulosFacturacion"];
    },
    ...mapGetters({
      loading: "loading",
      Informes: "pages/CargaArchivos",
      respuestaAnexosCargues: "pages/respuestaAnexosCargues",
    }),
    informeCarga() {
      let slug = this.$route.params.slug;
      //Validacion de retail
      //if (
      //slug == "reclamaciones-totales" &&
      //this.$store.state.user.user.sigBanco.retail == "SI"
      //) {
      //this.actualizacion_cliente_input = true;
      //}

      this.Informes.forEach((element) => {
        const bancoNit = this.$store.state.user.user.sigBanco.nit;
        const esRecaudos = element && element.nombre_permiso == "cargue_recaudos";
        const bancoTituloFacturacion = bancoNit && this.bancos_facturacion.includes(bancoNit);

        if (element.slug == slug) {
          if (esRecaudos && bancoTituloFacturacion) {
            element.titulo = element.titulo.replace("Recaudos", "Facturación");
            element.texto = element.texto.replace("Recaudo", "Facturación");
            element.intro = element.intro.replace("recaudos", "facturación");
            element.recomendacion = element.recomendacion.replace("recaudo", "facturación");
          }
          this.text = "Carga de archivos - " + element.titulo;
          this.intro = element.intro;
          this.recomendacion = element.recomendacion;
          this.tipo_archivo = element.tipo_archivo ? element.tipo_archivo : "";
          this.multiple = element.multiple ? element.multiple : "";

          return element;
        }

      });
    },
    loadCargue() {
      var slug = this.$route.params.slug;

      this.Informes.forEach((element) => {
        if (element.slug == slug) {
          this.texto = "Carga de archivos - " + element.titulo;
          this.intro = element.intro;
          this.recomendacion = element.recomendacion;
        }
      });
    },
  },
  components: {
    Titulo: () => import("@/containers/layout/Titulo.vue"),
    SelectComponet: () => import("@/components/form/Select.vue"),
    Recomendaciones: () => import("@/containers/layout/Recomendaciones.vue"),
    BannerRight: () => import("@/containers/layout/banner-right.vue"),
  },
  methods: {
    limpiarInputReset() {
      this.$refs.archivo.reset();
    },
    fileChange(fileList) {
      this.name = this.$refs["archivo"].$refs.input.files[0].name;

      this.files.append(
        "cargues[]",
        this.$refs["archivo"].$refs.input.files[0]
      );
      this.checkFile();
    },
    fileChangeCliente(fileList) {
      this.files.append(
        "actualizacion_cliente",
        this.$refs["archivo_cliente"].$refs.input.files[0]
      );
    },
    cargue() {
      if (this.informeCarga && this.informeCarga.ruta_guardado) {
        this.files.append("ruta", this.informeCarga.ruta_guardado);
      }

      this.files.append("slug", this.$route.params.slug);

      let upload = new Promise((res, rej) => {
        this.$store.commit("SET_LOADING", true);
        this.$store.getters.api
          .post(
            this.informeCarga
              ? this.informeCarga.endpoint
                ? this.informeCarga.endpoint
                : "portal"
              : "portal",
            this.files
          )
          .then((response) => {
            res(response);
          })
          .catch((error) => {
            rej(error);
          });
      });

      upload
        .then((response) => {
          this.files = new FormData();
          this.uploadResponse = response.data;
          this.showDismissibleAlertSuccess = true;
          this.limpiarInputReset();
        })
        .catch((error) => {
          this.uploadRespnseError = error.response.data;
          this.showDismissibleAlertError = true;
        })
        .then(() => {
          this.$store.commit("SET_LOADING", false);
        });
    },
    checkFile() {
      let inicial = this.name.split("_")[0].toUpperCase();
      let aceptados = [];

      switch (this.$route.params.slug) {
        case "registros-nuevos":
          aceptados = ["G"];
          break;
        case "utilizaciones":
          aceptados = ["U"];
          break;
        case "novaciones-plazo":
        case "novaciones-saldo":
          aceptados = ["N", "V"];
          break;
        case "renovaciones":
          aceptados = ["E"];
          break;
        case "refinanciaciones":
          aceptados = ["F"];
          break;
        case "desistimiento-garantia":
          aceptados = ["D"];
          break;
        case "cartera":
          aceptados = ["C", "R"];
          break;
        case "reclamaciones-totales":
          aceptados = ["T", "TRO"];
          break;
        case "reclamaciones-parciales":
          aceptados = ["P"];
          break;
        case "preaprobados":
          aceptados = ["S"];
          break;
        case "anexo-de-reclamacion":
          inicial = "TRUE";
          aceptados = "TRUE";
          break;
        case "reestructuraciones":
          aceptados = ["A"];
          break;
        case "no-garantizados":
        case "operaciones-no-garantizados":
          aceptados = ["Z", "ZRO"];
          break;
        case "aumento-cupo":
          aceptados = ["O"];
          break;
        case "venta-de-cartera":
          aceptados = ["VC"];
          break;
        case "reclamaciones-excepcion":
          aceptados = ["X"];
          break;
        case "recaudos":
          aceptados = ["RE"];
          break;
        default:
          this.fileChecked = true;
      }

      this.fileChecked = aceptados.includes(inicial);
    },
  },
  created: function () {
    this.$store.dispatch("pages/fetchTitulosFacturacion", {
      endpoint: "configuracion/label_facturacion_portal",
      params: {
        paginar: "false",
      },
    });
  },
};
</script>
